// extracted by mini-css-extract-plugin
module.exports = {"slider__wrapper":"S_dB","slider__element":"S_dC","itemSlider":"S_dD","itemSlider__slideWrapper":"S_dF","itemSlider__pagination":"S_dG","activeSlide":"S_dH"};